<template>
    <kt-row>
        <kt-col lg="6" md="6" sm="12">
            <kt-form-group>
                <kt-form-label for="merchant_number">
                    {{ $t('label.merchant_number') }}
                </kt-form-label>
                <kt-form-control
                        id="merchant_number"
                        name="merchant_number"
                        v-model="psp_request.merchant_number"
                        class="form-control"
                ></kt-form-control>
            </kt-form-group>
        </kt-col>
        <kt-col lg="6" md="6" sm="12">
            <kt-form-group>
                <kt-form-label for="terminal_number">
                    {{ $t('label.terminal_number') }}
                </kt-form-label>
                <kt-form-control
                        id="terminal_number"
                        name="terminal_number"
                        v-model="psp_request.terminal_number"
                        class="form-control"
                ></kt-form-control>
            </kt-form-group>
        </kt-col>
        <kt-col lg="6" md="6" sm="12">
            <kt-form-group>
                <kt-form-label for="username">
                    {{ $t('label.username') }}
                </kt-form-label>
                <kt-form-control
                        id="username"
                        name="username"
                        v-model="psp_request.port_config.username"
                        class="form-control"
                ></kt-form-control>
            </kt-form-group>
        </kt-col>
        <kt-col lg="6" md="6" sm="12">
            <kt-form-group>
                <kt-form-label for="password">
                    {{ $t('label.password') }}
                </kt-form-label>
                <kt-form-control
                        id="password"
                        name="password"
                        v-model="psp_request.port_config.password"
                        class="form-control"
                ></kt-form-control>
            </kt-form-group>
        </kt-col>
    </kt-row>
</template>

<script>
export default {
    props: {
        psp_request: {
            required: true,
            type: Object,
            default() {
                return {}
            }
        }
    }
}
</script>

<style>
</style>